export default "__VITE_ASSET__ktSXZAIihv_0EA_iN3QxeA__";